import * as _ from 'underscore';
import * as angular from 'angular';

class NfcRetailerTabList {
    static $inject = ['$scope', '$translate', '$uibModal'];


    constructor(
        public $scope: ng.IScope,
        protected $translate: angular.translate.ITranslateService,
        private $uibModal: ng.ui.bootstrap.IModalService,
    ) {
    }

    export = async () => {
        let operationResult: any = await this.$uibModal.open({
            component: 'nfcExport',
            resolve: { },
            size: 'md',
            backdrop: 'static',
        }).result;
    }

}

angular.module('naut').component('nfcRetailerTabList', {
    template: require('./nfc-retailer-tab-list.component.html'),
    controller: NfcRetailerTabList,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/tabs-list/nfc-retailer-tab-list.component.ts